import { render, staticRenderFns } from "./ModalViewVideo.vue?vue&type=template&id=4ca0994b&"
import script from "./ModalViewVideo.vue?vue&type=script&lang=js&"
export * from "./ModalViewVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports